import React from 'react';
import { Button } from '@raptormaps/button';
import { Stack } from '@raptormaps/layout';
import { Text } from '@raptormaps/text';

interface NoPartnerViewProps {
  onAdd: () => void;
}

export function NoPartnerView({ onAdd }: NoPartnerViewProps) {
  return (
    <Stack gutter="md">
      <Text variant="paragraph_small" color="#718096">
        No partner linked.
      </Text>
      <Button variant="primary" onClick={onAdd}>
        Add Partner
      </Button>
    </Stack>
  );
}
